//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.Subdivision.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../Features/Features.Subdivision.SelectCageObjectData.js";
import "../GeometricUtilities/GeometricUtilities.TransformerData.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/Features.js";
import "../no/GeometricUtilities.js";
let d=[[[0,"CanMoveToolOnly",1,0],[0,"CanRelocateToolToSelection",1,0],[0,"CanReorientToolToSelection",1,0],[0,"Continuity",1,0],[0,"DirectionOption",1,0],[1,"Distance",0,"Expression",0],[0,"NumberOfSegments",1,0],[0,"PreviewCage",0,"SubdivisionMeshBody",0],[0,"ScalingMethod",1,0],[1,"SelectionObject",0,"Features.Subdivision.SelectCageObjectData",0],[0,"TransformationMethod",1,0],[1,"Transformer",0,"GeometricUtilities.TransformerData",0],[0,"Vector",1,"Direction",0]],[[[],"Extrude",{},0,0],[["isGeometryEvaluated","origin","direction"],"EvaluateDistanceHandleGeometry",{},0,0]],[]];
SPLM.Features.Subdivision.SubdivisionExtrudeCageBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.Subdivision.SubdivisionExtrudeCageBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.Subdivision.SubdivisionExtrudeCageBuilder.TransformationMethodType = Object.freeze({
    "DragLinear" : "DragLinear", "Transform" : "Transform"});

SPLM.Features.Subdivision.SubdivisionExtrudeCageBuilder.DirectionType = Object.freeze({
    "Inferred" : "Inferred", "Vector" : "Vector", "Perpendicular" : "Perpendicular"});

SPLM.Features.Subdivision.SubdivisionExtrudeCageBuilder.ContinuityType = Object.freeze({
    "Smooth" : "Smooth", "Sharp" : "Sharp"});

SPLM.Features.Subdivision.SubdivisionExtrudeCageBuilder.ScalingMethodType = Object.freeze({
    "Linear" : "Linear", "Planar" : "Planar", "Uniform" : "Uniform"});

export default SPLM;